import React from 'react'
import filter from 'lodash/filter'

import { OptionsMenu } from '../data-card/data-card-parts'

class IssueCardOptions extends React.Component {
  markAsPermanentItem () {
    if (this.props.issue.permissions.canMarkAsPermanent) {
      return {
        name: 'Mark as Permanent',
        action: this.props.onMarkAsPermanent
      }
    }
  }

  deleteItem () {
    if (this.props.issue.permissions.canDestroy) {
      return {
        name: 'Delete',
        action: this.props.onDelete
      }
    }
  }

  editItem () {
    const { issue } = this.props

    if (issue.permissions.canUpdate) {
      return {
        name: 'Edit Issue',
        link: `location-issues/${issue.location}/issue/${issue.id}/edit`
      }
    }
  }

  render () {
    const actions = [this.editItem(), this.markAsPermanentItem(), this.deleteItem()]
    const availableActions = filter(actions, item => item)

    return <OptionsMenu optionItems={availableActions} />
  }
}

export default IssueCardOptions



// WEBPACK FOOTER //
// ./src/components/issues/issue-card-options.js